import { useEffect, useRef, useContext, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import VectorSource from "ol/source/Vector.js";
import VectorLayer from "ol/layer/Vector";
import MapContext from "../../../MapContext";
import { Style, Fill, Stroke, Circle as CircleStyle } from "ol/style";
import { Point } from "ol/geom.js";
import Feature from "ol/Feature.js";
import { Button } from "@progress/kendo-react-buttons";
import { setResultsForFeature } from "../../../../redux/resultsSlice";
import { inAndOut } from "ol/easing";
import LayerPopup from "../LayerPopup";

const GeocodeDescription = () => {
    const { map } = useContext(MapContext);
    const dispatch = useDispatch();
    const vectorLayer = useRef();
    const results = useSelector((state) => state.resultsData);
    const [result] = results.resultsForFeature;
    const geoCodeData = useSelector(
        (state) => state.resultsData.geocodingData.candidates
    );
    const horizontalView = useSelector((state) => state.toolSelect.horizontalView);

    const geoData = geoCodeData.find(
        (c) => c.attributes.Match_addr === result.Features[0]
    );

    const feature = useMemo(() => {
        if (geoData === undefined) return;
        const feature = new Feature({
            geometry: new Point([geoData.location.x, geoData.location.y]),
            Id: geoData.attributes.Match_addr,
            attributes: geoData.attributes,
        });
        feature.setId(geoData.attributes.Match_addr);
        return feature;
    }, [result, geoCodeData]);

    useEffect(() => {
        if (geoData === undefined) return;
        vectorLayer.current = new VectorLayer({
            source: new VectorSource({ features: [feature] }),
            map: map,
            style: highlightStyle,
            zIndex: 100,
        });
        const extent = feature.getGeometry().getExtent();
        map.getView().fit(extent, { easing: inAndOut, duration: 750, minResolution: 1 });
        return () => {
            vectorLayer.current.getSource().clear();
        };
    }, [result, geoCodeData]);

    return (
        <>
            {geoData && !horizontalView ? (
                <>
                    {results.resultsForLayer.length > 0 && (
                        <Button
                            style={{
                                position: "absolute",
                                zIndex: "20",
                                cursor: "pointer",
                            }}
                            icon="arrow-left"
                            onClick={() => {
                                dispatch(setResultsForFeature([]));
                            }}></Button>
                    )}
                    <div style={{ float: "right", paddingTop: "10px" }}>
                        <LayerPopup feature={feature} layerId={"ArcGIS Geocoder"} />
                    </div>
                    <br />
                    <div className="results-title" style={{ marginTop: "10px" }}>
                        {geoData.address}
                    </div>
                    <div className="description-header">Details</div>
                    <div className="results-field">Address</div>
                    <div className="results-field-value">{geoData.address}</div>
                    <div className="results-field">Score</div>
                    <div className="results-field-value">{geoData.score}</div>
                </>
            ) : geoData && horizontalView ? (
                <>
                    <div style={{ float: "right", paddingTop: "10px" }}>
                        <LayerPopup feature={feature} layerId={"ArcGIS Geocoder"} />
                    </div>
                    <div className="results-title" style={{ marginTop: "10px" }}>
                        {geoData.address}
                    </div>
                    <div className="description-header">Details</div>
                    <div className="results-field">Address</div>
                    <div className="results-field-value">{geoData.address}</div>
                    <div className="results-field">Score</div>
                    <div className="results-field-value">{geoData.score}</div>
                </>
            ) : (
                <div />
            )}
        </>
    );
};

export default GeocodeDescription;

const highlightStyle = new Style({
    zIndex: 100,
    stroke: new Stroke({
        color: "blue",
        width: 2,
    }),
    image: new CircleStyle({
        radius: 10,
        stroke: new Stroke({
            color: "blue",
            width: 4,
        }),
    }),
});
